import { GET_ACTIVITY_FEED_FIELD_NAME } from 'activity-feed-lib/hooks/useFetchActivityFeed';
const removeDuplicates = (existing, incoming) => {
  const existingIds = existing.map(event => event.id);
  /**
   * Since both existing and incoming are already in chronological order, once we hit a
   * match, we know that all events after that match are duplicates as well.
   */
  for (let i = 0; i < incoming.length; i++) {
    if (existingIds.includes(incoming[i].id)) {
      return incoming.slice(0, i);
    }
  }
  return incoming;
};
const ACTIVITY_FEED_FIELD_POLICY = {
  [GET_ACTIVITY_FEED_FIELD_NAME]: {
    /**
     * This is all the variables that the cache will depend on.
     * It sets which will be the variables to look for to determine if it should refetch
     */
    keyArgs: ['objectId', 'objectTypeId', 'startTimestamp', 'endTimestamp', 'activityTypes', 'userId', 'searchQuery'],
    merge(existing, incoming) {
      if (!existing || !existing.results.length) {
        return incoming;
      }
      if (!incoming) {
        return existing;
      }
      if (!incoming.results.length) {
        return Object.assign({}, incoming, {
          results: existing.results
        });
      }

      /**
       * This should never evaluate to true since the only time we merge is when the user
       * is getting events in the past or when the polling determines there is a new event
       */
      if (existing.results[0].id === incoming.results[0].id) {
        return existing;
      }

      /**
       * Potentially the incoming results may need to slot into the existing results due to
       * there being more new results than the fetch limit. This loop will compare the first event timestamp
       * to each existing event timestamp and then slot in the entire sanitized result once it finds an event
       * that occurred before it. We don't need to check the other events and can assume the overlap will be at the
       * tail-end of the the incoming results due to the chronological nature of the events.
       */
      for (let i = 0; i < existing.results.length; i++) {
        if (existing.results[i].timestamp < incoming.results[0].timestamp) {
          const sanitizedIncomingResults = removeDuplicates(existing.results, incoming.results);
          const newResults = [...existing.results];
          newResults.splice(i, 0, ...sanitizedIncomingResults);
          return Object.assign({}, existing, {
            results: newResults
          });
        }
      }
      const sanitizedIncomingResults = removeDuplicates(existing.results, incoming.results);
      if (!sanitizedIncomingResults.length) {
        return existing;
      }
      return Object.assign({}, incoming, {
        results: [...existing.results, ...sanitizedIncomingResults]
      });
    }
  }
};
export const activityFeedQueryFieldPolicies = Object.assign({}, ACTIVITY_FEED_FIELD_POLICY);